// React
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  FloatButton,
  DropdownDatatable,
} from '../../containers/componentsInjection';

export const SellersPage = ({
  history,
  columns,
  handleEdit,
  handleDelete,
  setActiveStatus,
  makeDataToFilter,
}) => {
  return (
    <PageWrapper title={'Corretores'}>
      <Row>
        <Col xs={12}>
          <div id="table-gridjs">
            <Card>
              <DropdownDatatable
                keysSearch={['name', 'cpf']}
                title="Corretores"
                titleButton="Novo corretor"
                columns={columns}
                pagination
                persistTableHead
                perPage={10}
                data={makeDataToFilter()}
                isSearchRemote={false}
                actions={[
                  {
                    id: 1,
                    name: 'edit',
                    label: 'Editar',
                    onPress: (cellProps) => handleEdit(cellProps),
                    icon: 'la-pen',
                    classNameColorIcon: 'primary',
                  },
                ]}
                handleDelete={(cellProps) => handleDelete(cellProps)}
                hasStatusSelect
                handleStatusSelect={(e) => setActiveStatus(e.target.value)}
              />
            </Card>
          </div>
        </Col>
      </Row>
      <FloatButton handleButton={() => history.push('/corretores/novo')} />
    </PageWrapper>
  );
};
